import { Component, OnInit,ViewChild  } from '@angular/core';
import { CalendarOptions } from '@fullcalendar/angular'; // useful for typechecking
import { Calendar } from '@fullcalendar/core';
import { fuseAnimations } from '@fuse/animations';
import allLocales from '@fullcalendar/core/locales-all';
import {TranslateService} from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ModalCalendInfoComponent } from './modal-calend-info/modal-calend-info.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import esLocale from '@fullcalendar/core/locales/es';
import frLocale from '@fullcalendar/core/locales/fr';
import * as $ from 'jquery';
import { FullCalendarComponent } from '@fullcalendar/angular';
import {FormGroup, FormControl} from '@angular/forms';
import { CalendSurveyService } from "./calendsurvey.service";
import { lang_calend } from 'app/idiomas/i18n/calend-survey/calend.lang';
const moment = require('moment');
const momentTz = require('moment-timezone');
import { DatePipe } from '@angular/common';
import {DateAdapter} from '@angular/material/core';
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-calendsurvey',
  templateUrl: './calendsurvey.component.html',
  styleUrls: ['./calendsurvey.component.scss'],
  animations : fuseAnimations
})

export class CalendsurveyComponent implements OnInit {
  idiomaActual:any;
@ViewChild('calendar') calendarComponent: FullCalendarComponent;
//   calendar: new Calendar={
//   locales: allLocales,
//   locale: 'en' // the initial locale
// };

  events: any=[
    // {title: 'Steren', date:'2022-06-27',color:'#14D504',status:1,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_1', date:'2022-06-27',color:'#0000FF',status:2,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_2', date:'2022-06-27',color:'#A2A2A2 ',status:0,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren', date:'2022-06-27',color:'#14D504',status:1,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_1', date:'2022-06-27',color:'#0000FF',status:2,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_2', date:'2022-06-27',color:'#A2A2A2 ',status:0,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren', date:'2022-06-27',color:'#14D504',status:1,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_1', date:'2022-06-27',color:'#0000FF',status:2,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
    // {title: 'Steren_2', date:'2022-06-27',color:'#A2A2A2 ',status:0,fechaCierre:"2022-06-24T08:00:00.000Z",fechaLanzamiento:"2022-02-11T08:00:00.000Z",tipoProducto:40,fechaProducto:2022},
  ];

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    events: this.events,
    locale:this.translateSrv.currentLang,
    eventClick: this.handleDateClick.bind(this),
     weekends: true,
    dayMaxEvents: 6,
    dayMaxEventRows: 4,
    // validRange:{start: '2020-01-01',end: '2022-02-28'}
  };
  cargando:boolean=false;
  mostrarCalen:boolean=false;
  instituto:any;
  institutos:any;
  userItbm:boolean=false;
  diferenciaUtc: number;
  offsetPipe: string;
  zonasUTC = zonasUTC;
  indiceZona: number;
  fechaInicioBu:any;
  fechaFinalBu:any;
  constructor(
      private translateSrv: TranslateService,
      public dialog: MatDialog,
      private serviceCalend: CalendSurveyService,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private datePipe: DatePipe,
      private dateAdapter: DateAdapter<Date>,
  ) {
    lang_calend.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.idiomaActual = this.translateSrv.currentLang;
    this.dateAdapter.setLocale(''+this.idiomaActual+'');
    this.translateSrv.onLangChange.subscribe(() => {
      this.dateAdapter.setLocale(''+this.idiomaActual+'');
      console.log('Idioma::',this.translateSrv.currentLang);
    let idioma:any;
    switch (this.translateSrv.currentLang) {
      case 'zh1':
        idioma="zh-tw"
        break;
      case 'zh2':
        idioma="zh-cn"
        break;

      default:
      idioma=this.translateSrv.currentLang;
        break;
    }
     this.calendarOptions.locale=idioma

   });
  }

  ngOnInit(): void {
    console.log('instituto',this.instituto);

    this.getInstitutos();
    const instituto = localStorage.getItem('instituto_id');
    if(instituto != '0'){ //si el instituto no es 0 (usuario itbm) se oculta la lista del broker
      this.instituto = parseInt(instituto);
      this.userItbm=false;
      this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instituto);
      console.log('this.indiceZona',this.indiceZona);
      this.calculoOffsetPipe();
      // this.anchoListas = 45;
    } else{
      this.userItbm=true;
      // this.anchoListas = 30;
    }
  }

  getInstitutos(){
    this.serviceCalend.getInstitutos().subscribe((respuesta:any) => {
      console.log("getInstitutos:",respuesta);
      if(respuesta.success){
        this.institutos=respuesta.Institutos;

      }
    });
  }

instiSelec(){
this.indiceZona = this.zonasUTC.findIndex(item => item.instituto == this.instituto);
console.log('this.indiceZona',this.indiceZona);
this.calculoOffsetPipe();

}
handleDateClick(info:any){
  console.log('informacion del evento',info.event._context.dateProfileGenerator.nowDate);
  console.log('informacion del evento',info.event._def);
  console.log('informacion del evento',info.event._def.extendedProps);
  const dialogRef = this.dialog.open(ModalCalendInfoComponent, {
    width: '40%',
    height: '60%',
    data: {
      nombreEmpresa: info.event.title,
      dateLanza: info.event._context.dateProfileGenerator.nowDate,
      infoExtra:info.event._def.extendedProps,
    }
  });
  // dialogRef.afterClosed().subscribe(result => {
  // });
}

buscarEncue(){

  console.log('fechaInicioBu',this.fechaInicioBu);
  console.log('fechaFinalBu',this.fechaFinalBu);
  let fechaInicio=moment(this.fechaInicioBu).format();
  let fechaFinal=moment(this.fechaFinalBu).format();
  console.log('fechaInicio',fechaInicio);
  console.log('fechaFinal',fechaFinal);

  let date1=moment(fechaInicio).set({hour:0,minute:0,second:0,millisecond:0});
  let date2=moment(fechaFinal).set({hour:0,minute:0,second:0,millisecond:0});
  console.log('fechaInicio',moment(date1));
  console.log('fechaFinal',moment(date2));
  this.cargando=true;
  this.serviceCalend.getCalendSurveys(this.instituto,date1._i,date2._i).subscribe((respuesta:any) => {
    this.mostrarCalen=true;
    let surveyCalend:any=[];
    respuesta.result.forEach(survey => {
      surveyCalend.push(
        {
          color:survey.color,
          close_date:survey.close_date,
          // close_date:this.datePipe.transform(new Date(survey.close_date),'dd MMM YYYY HH:mm:ss',this.offsetPipe,undefined),
          date: this.datePipe.transform(new Date(survey.date),'yyyy-MM-dd',this.offsetPipe,undefined),
          productId: survey.productId,
          surveyToken: survey.surveyToken,
          survey_status: survey.survey_status,
          survey_type: survey.survey_type,
          survey_year: survey.survey_year,
          title: survey.title,
          launch_date: survey.date,
          offsetPipe: this.offsetPipe,
          indiceZona:this.indiceZona,
        }
      )
    });
    console.log('surveyCalend',surveyCalend);
setTimeout(() => {
  this.events=surveyCalend;
  let calendario:CalendarOptions={
    initialView: 'dayGridMonth',
    events:this.events,
    locale:this.translateSrv.currentLang,
    dayMaxEvents: 4,
    eventClick: this.handleDateClick.bind(this),
    validRange:{start: moment(fechaInicio).format('YYYY-MM-DD'),end: moment(fechaFinal).format('YYYY-MM-DD')+' 24:00:00'},
  }
  this.calendarOptions=calendario;
  this.cargando=false;
}, 1000);

  });
}

calculoOffsetPipe(diff?:any){
  this.diferenciaUtc = moment.parseZone(momentTz.tz(this.zonasUTC[this.indiceZona].zona).format()).utcOffset();
  console.log("diferenciaUtc:",this.diferenciaUtc);
  let horas = diff!=undefined?diff/60:this.diferenciaUtc / 60;
  if(horas < 0){
    horas = horas * -1;
    if(horas < 10){
      this.offsetPipe = "-0" + horas + "00";
    }
    else{
      this.offsetPipe = "-" + horas + "00";
    }
  }
  else{
    if(horas < 10){
      this.offsetPipe = "+0" + horas + "00";
    }
    else{
      this.offsetPipe = "+" + horas + "00";
    }
  }
  console.log("offsetPipe:",this.offsetPipe);
}

}
